import queryString from 'query-string'
import { setLang } from '../lang'



let parsedQuery = queryString.parse(location.search)
if (parsedQuery.lang) {
	setLang(parsedQuery.lang)
	window.history.replaceState({}, null, '/')
}
